export default __webpack_public_path__ + "media/color/burst-ed1e7b47.svg";